//
//
//
//
//
//
//
//

import AppConfig from '@/config/app'

export default {
  name: 'm-product-nav',
  props: [
    'scroll-top',
    'offset-top',
    'active',
    'show'
  ],
  data () {
    return {
      navs: AppConfig.navs
    }
  },
  computed: {
    fixed () {
      if (this.scrollTop > this.offsetTop) {
        this.$emit('fixedNavChange', true)
        return true
      }
      this.$emit('fixedNavChange', false)
      return false
    },
    activeNav () {
      if (this.scrollTop >= this.active.nav4 - 50 ||
        (this.active.scroller && (this.scrollTop + this.active.scroller.clientHeight) === this.active.scroller.scrollHeight)) {
        return 'nav4'
      } else if (this.scrollTop >= this.active.nav3 - 50) {
        return 'nav3'
      } else if (this.scrollTop >= this.active.nav2 - 50) {
        return 'nav2'
      } else if (this.scrollTop >= this.active.nav1 - 50) {
        return 'nav1'
      }
    }
  },
  methods: {
    onClickNav (event) {
      this.$emit('clickNav', event.target.dataset.ref)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductNav.vue